export enum ExpertProfileSaveType {
  apply = 1,
  save = 0
}